export const toLocationOption = location => {
  const city = location?.city ?? "null"
  const country = location?.country
  const value = `${city}, ${country}`

  if (location?.name) {
    return {
      label: location.name,
      value,
    }
  }

  const label = location?.total === undefined
    ? `${location?.city}, ${country}`
    : `${location?.city}, ${country} (${location.total})`

  return {
    label,
    value,
  }
}

// Case- and diacritic-insensitive key for matching typed text against
// location labels: "zalau" finds "Zalău", "brasov" finds "Brașov" or "Braşov".
export const foldLocationText = text =>
  String(text ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase()
